import { render, staticRenderFns } from "./template-transform.vue?vue&type=template&id=2f81ce10"
import script from "./template-transform.vue?vue&type=script&lang=ts"
export * from "./template-transform.vue?vue&type=script&lang=ts"
import style0 from "./template-transform.vue?vue&type=style&index=0&id=2f81ce10&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports